/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import * as React from "react";
export function ExpressionNotSpecified() {
  return /*#__PURE__*/React.createElement("div", {
    className: "guided-expression-editor expression-not-specified"
  }, /*#__PURE__*/React.createElement("i", null, AbReactResources.expression_not_specified()));
}
//# sourceMappingURL=ExpressionNotSpecified.js.map
